import React from 'react';
import { Redirect } from 'react-router-dom';

export default function Index() {
  return <Redirect to="/init/existing_user" />;
}
